import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ButtonGroup, Button } from 'ui';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Modal from 'components/shared/modal';

const TRANSITION_TIMEOUT = { enter: 500, exit: 300 };

const ImageLibraryAddDialog = ({
  image = {},
  visible,
  toggleVisible,
  canManageContentLibrary,
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const [error, setError] = useState(null);

  const htmlLink = `<a target="_blank" rel="noopener noreferrer" class='u-link mb-24 d-ib' href="${
    routes.IMAGES
  }">${t('image_library.add_dialog.visit_library_link_text')}</a>`;

  function onDialogClose() {
    if (visible) {
      toggleVisible();
    }

    setError(false);
  }

  function addToLibrary() {
    setError(null);
    setIsAdding(true);

    request
      .put(routes.IMAGE_LIBRARY_VISIBILITY_ADD(image.id))
      .then(() => {
        onDialogClose();
        setIsAdding(false);
      })
      .catch(e => {
        console.error(e);
        setError(e);
        setIsAdding(false);
      });
  }

  return (
    <Modal
      show={visible}
      canClickAway={false}
      dismissCallback={onDialogClose}
      title={t('image_library.add_dialog.title')}
    >
      <div className="ff-ss mb-16">
        <CSSTransition
          classNames="CSSTransition fade"
          timeout={TRANSITION_TIMEOUT}
          in={!!error}
          unmountOnExit
        >
          <div className="ErrorContainer">{t('common.server_error')}</div>
        </CSSTransition>
        <b>{t('image_library.add_dialog.description')}</b>
        <div className="mt-16">
          {t('image_library.add_dialog.note')}{' '}
          {canManageContentLibrary && (
            <span
              dangerouslySetInnerHTML={{
                __html: t('image_library.add_dialog.visit_library_html', {
                  link: htmlLink,
                }),
              }}
            />
          )}
        </div>
      </div>
      <ButtonGroup alignEnd>
        <Button disabled={isAdding} onClick={onDialogClose}>
          {t('image_library.add_dialog.cancel')}
        </Button>
        <Button loading={isAdding} primary onClick={addToLibrary}>
          {t('image_library.add_dialog.add')}
        </Button>
      </ButtonGroup>
    </Modal>
  );
};

export default ImageLibraryAddDialog;
